<template>
    <div id="address-add">
        <div id="receive-address-header">
        </div>

        <div id="address-add-item">
            <div class="address-input">
                <div class="address-title">收货人</div>
                <input v-model="consignee" type="text" class="item-input" placeholder="请输入收货人姓名" maxlength="15"
                       minlength="2">
            </div>

            <div class="address-input">
                <div class="address-title">电话</div>
                <input v-model="mobile" type="tel" class="item-input" placeholder="请输入电话号码" maxlength="11">
            </div>

            <div class="address-input" @click="handleClickArea">
                <div class="address-title">地址</div>
                <input v-if="area" :value="`${city} ${area}`" type="text" class="item-input" style="float: left;"
                       placeholder="请选择收货地址" readonly/>
                <input v-else class="item-input" placeholder="请选择收货地址" readonly/>
            </div>

            <div class="address-input">
                <div class="address-title">详细地址</div>
                <input v-model="address" type="text" class="item-input" placeholder="例：1号楼101室" maxlength="30">
            </div>

<!--            <div class="question-answer">-->
<!--              <div class="question-text">益力多水蜜桃味的产品特征是什么?（必填）</div>-->
<!--              <div class="answer-input">-->
<!--                <input v-model="questionAnswer" type="text" class="item-input" placeholder="请输入您的回答" maxlength="100" />-->
<!--              </div>-->
<!--            </div>-->
        </div>

        <button id="address-add-new-address" @click="saveAddress" :disabled="btnDisable">
            保存地址
        </button>
        <div class="back-btn" @click="backBtn">返回</div>
        <template v-if="showRegionPicker">
            <div class="mask"></div>
            <div class="fixed-bottom">
                <region-picker
                    v-model="selectedValues"
                    :columns="cityColumns"
                    @change="handleChange"
                />

                <div class="button-container">
                    <div class="common-btn" @click="handleCancel">取消</div>
                    <div class="common-btn" @click="handleConfirm">确认</div>
                </div>
            </div>
        </template>

        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
    </div>
</template>

<script>
// import {AddAddress} from "../../api/Address";
import RegionPicker from '../../components/RegionPicker.vue';
import {ListUrbanArea} from "../../api/Area";
import {isChinese} from "../../unitls";

export default {
    name: "ActivityAddressAdd",
    components: {RegionPicker},
    data() {
        return {
            addressId: '', // this.$route.query.id,
            consignee: '',
            mobile: '',
            city: '',
            area: '',
            address: '',
            // questionAnswer: '',

            isSuccess: false,

            btnDisable: false,

            toastShow: false,
            toastText: '',

            isAddressShow: false,
            tips: [],
            showRegionPicker: false, // 是否显示地区选择器
            cityData: [],

            currentSelectedValues: [0, 0],
            selectedValues: [0, 0],
            cityColumns: []
        }
    },

    mounted() {
        this.requestUrbanAreaList();
    },

    methods: {
        requestUrbanAreaList() {
            ListUrbanArea().then((response) => {
                if (response.code === this.$API_CODE.OK) {
                    this.cityData = response.data;
                    this.cityColumns = [
                        {
                            values: this.cityData,
                            offset: 0,
                            activeIndex: 0
                        },
                        {
                            values: this.cityData[0].children,
                            offset: 0,
                            activeIndex: 0
                        }
                    ]
                }
            })
        },
        handleCancel() {
            this.selectedValues = [...this.currentSelectedValues];
            this.cityColumns.forEach((column, index) => {
                column.activeIndex = this.selectedValues[index];
                column.offset = -this.selectedValues[index] * 36;
                if (index === 0) {
                    console.log(this.cityData, this.selectedValues[index]);
                    this.cityColumns[1].values = this.cityData[this.selectedValues[index]].children;
                }
            })
            this.showRegionPicker = false;
            console.log(this.currentSelectedValues);
        },

        handleConfirm() {
            this.currentSelectedValues = [...this.selectedValues];
            this.showRegionPicker = false;
            this.city = this.cityData[this.currentSelectedValues[0]].name;
            this.area = this.cityData[this.currentSelectedValues[0]].children[this.currentSelectedValues[1]].name;
            console.log(this.currentSelectedValues);
        },

        handleClickArea() {
            this.showRegionPicker = true;
        },

        handleChange(index) {
            if (index === 0) {
                this.cityColumns[1].transition = false;
                this.cityColumns[1].values = this.cityData[this.cityColumns[0].activeIndex].children;
                this.cityColumns[1].offset = 0;
                this.cityColumns[1].activeIndex = 0;
            }
        },
        backBtn() {
            console.log('backBtn')
            this.$router.back();
        },

        toast(e) {
            let _that = this;
            this.toastText = e;
            this.toastShow = true;
            setTimeout(function () {
                _that.toastShow = false;
                if (_that.isSuccess) {
                    _that.$router.go(-1);
                }
            }, 1000)
        },

        // 点击保存按钮
        saveAddress() {
            if (this.consignee === '') {
                this.toast('请输入收货人姓名');
                return;
            }
            if (!isChinese(this.consignee)) {
                this.toast('收货人姓名必须是汉字');
                return;
            }
            if (this.consignee.trim().length < 2) {
                this.toast('收货人姓名必须在2-15位');
                return;
            }
            if (this.mobile === '') {
                this.toast('请输入电话号码');
                return;
            }

            let telReg = /^1[3456789]\d{9}$/;
            if (!telReg.test(this.mobile)) {
                this.toast("请输入正确的电话号码");
                return;
            }
            if (this.city === '' || this.area === '') {
                this.toast('请选择地址');
                return;
            }
            if (this.address === '') {
                this.toast('请输入详细地址');
                return;
            }

            // if (this.questionAnswer === '') {
            //   this.toast('')
            // }
            if (this.isDefault === '') {
                this.isDefault = false;
            }

            if (this.distributionCenterId === '' || this.lat === '') {
                this.toast('地址所属配送范围无效，请重新选择');
                return;
            }

            // this.btnDisable = true;
            console.log('saveAddress')
            const params = { consignee: this.consignee, mobile: this.mobile, city: this.city, area: this.area, address: this.address };
            this.$router.push({path: '/verifyAddress', query: params});
        }
    }
}
</script>

<style scoped lang="scss">
#address-add {
    height: 100%;
    width: 100%;
    position: absolute;
    background: #fdf9f7;

    //header区域
    #receive-address-header {
        height: 6rem;
        line-height: 35px;
        background: url("../../assets/detail.png") no-repeat;
        background-size: 100% 6rem;
        width: 100%;

        .receive-address-title {
            color: white;
            float: right;
            margin-right: 20px;
            margin-top: 2rem;
            font-weight: bold;
            font-size: 1rem;
        }
    }

    #address-add-item {
        margin-top: 10px;

        .address-input {
            height: 3rem;
            margin-top: 10px;
            text-align: left;
            line-height: 3rem;
            padding-left: 20px;
            padding-right: 20px;
            border-top: 1px solid #dddddd;
            border-bottom: 1px solid #dddddd;
            background: #FFFFFF;

            .address-title {
                width: 4rem;
                height: 3rem;
                float: left;
                font-size: 0.9rem;
            }

            .item-input {
                border: 0;
                font-size: 0.9rem;
                color: #000000;
                height: 2.8rem;
                background: unset;
                width: 60%;
            }

            .address-title-next {
                float: right;
                margin-top: 15px;
                margin-bottom: 15px;
            }
        }

        .default-address {
            text-align: left;
            margin-left: 1rem;
            font-size: 0.9rem;

            .address-switch {
                float: left;
            }

            .default-address {
                margin-top: 10px;
                margin-left: 20px;
                padding-top: 5px;
            }

            /* Switch开关样式 */
            /* 必须是input为 checkbox class 添加 switch 才能实现以下效果 */
            input[type='checkbox'].address-switch {
                outline: none;
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
                position: relative;
                width: 2.5rem;
                height: 1.25rem;
                background: #ccc;
                border-radius: 10px;
                transition: border-color .3s, background-color .3s;
            }

            input[type='checkbox'].address-switch::after {
                content: '';
                display: inline-block;
                width: 1rem;
                height: 1rem;
                border-radius: 50%;
                background: #fff;
                transition: .4s;
                top: 2px;
                position: absolute;
                left: 2px;
                font-size: 0.9rem;
            }

            input[type='checkbox'].address-switch:checked {
                background: #ea2d53;
            }

            /* 当input[type=checkbox]被选中时：伪元素显示下面样式 位置发生变化 */
            input[type='checkbox'].address-switch:checked::after {
                content: '';
                position: absolute;
                left: 55%;
                top: 2px;
            }
        }

      .question-answer {
        margin-top: 10px;
        background: #FFFFFF;
        padding: 10px 20px;
        border-top: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }

      .question-text {
        font-size: 0.9rem;
        color: #000000;
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #dddddd;
        text-align: left;
      }

      .answer-input .item-input {
        border: 0;
        font-size: 0.9rem;
        color: #000000;
        height: 1.8rem;
        background: unset;
        width: 100%;
      }

      .answer-input {
        position: relative;
      }

    }

    #address-add-new-address {
        height: 3rem;
        line-height: 1.5rem;
        background: #ea2d53;
        right: 0;
        bottom: 0;
        left: 0;
        width: 50%;
        position: fixed;
        z-index: 1;
        color: #FFFFFF;
        font-size: 1rem;
        border: none;
        border-radius: 0;
    }

    .back-btn {
        position: fixed;
        z-index: 1;
        right: 0;
        bottom: 0;
        background: #fdf9f7;
        margin: auto;
        width: 50%;
        font-size: 1rem;
        font-weight: bold;
        color: #ea2d53;
        border: 1px solid #ea2d53;
        height: 3rem;
        line-height: 3rem;
    }

    .mask {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 99; /* 低于内容层 */
        opacity: 1;
        transition: opacity 0.3s, visibility 0.3s;
    }

    .fixed-bottom {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 100; /* 确保在其他元素上方 */
        background: white;
        padding: 20px;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        height: 50%;
    }

    .button-container {
        display: flex;
        justify-content: space-around;
        padding: 20px; /* 增加内边距，让按钮靠下 */
        margin-top: auto; /* 让按钮容器靠下 */
    }

    /* 定义共同的按钮样式 */
    .button-container {
        display: flex;
        justify-content: space-around;
        padding: 20px; /* 增加内边距，让按钮靠下 */
        margin-top: auto; /* 让按钮容器靠下 */
    }

    /* 定义共同的按钮样式，增加按钮横向长度 */
    .common-btn {
        padding: 10px 50px; /* 增大左右内边距，让按钮更宽 */
        background-color: #F8F8F8;
        color: #000000;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        text-align: center;
        font-size: 16px;
    }

    .toast {
        position: fixed;
        z-index: 2000;
        left: 50%;
        top: 50%;
        transition: all .5s;
        -webkit-transform: translateX(-50%) translateY(-50%);
        -moz-transform: translateX(-50%) translateY(-50%);
        -ms-transform: translateX(-50%) translateY(-50%);
        -o-transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
        text-align: center;
        border-radius: 5px;
        color: #FFF;
        background: rgba(17, 17, 17, 0.7);
        padding: 1rem;
        font-size: 1rem;
        line-height: 1.5rem;
    }
}
</style>